import { splitCurrencyPair } from "utils";

import { useAPIExchangesMetadataGlobal } from "./useAPI";

function useExchangesMetadataGlobal(currencyPair: string) {
  const { data } = useAPIExchangesMetadataGlobal();
  const { baseCurrency, counterCurrency } = splitCurrencyPair(currencyPair);

  const getCurrencyDisplayedScale = (currencyEnum: string) => {
    return data?.currencies?.[currencyEnum]?.displayed_scale ?? 2;
  };

  const getCurrencyScale = (currencyEnum: string) => {
    return data?.currencies?.[currencyEnum]?.scale ?? 2;
  };

  const getCurrencyShortDisplayedScale = (currencyEnum: string) => {
    return data?.currencies?.[currencyEnum]?.short_scale ?? getCurrencyDisplayedScale(currencyEnum);
  };

  return {
    data,
    counterCurrDisplayedScale: getCurrencyDisplayedScale(counterCurrency),
    baseCurrDisplayedScale: getCurrencyDisplayedScale(baseCurrency),
    counterCurrScale: getCurrencyScale(counterCurrency),
    baseCurrScale: getCurrencyScale(baseCurrency),
    counterCurrShortDisplayedScale: getCurrencyShortDisplayedScale(counterCurrency),
    baseCurrShortDisplayedScale: getCurrencyShortDisplayedScale(baseCurrency),
  };
}

export default useExchangesMetadataGlobal;
